import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import 'datatables.net'; // Import DataTables
import { query, where, db, collection, doc, setDoc, getDocs, deleteDoc, orderBy, onSnapshot, updateDoc, getDoc, arrayRemove, arrayUnion } from '../../config/firebaseConfig.js'; // Pastikan jalur benar
import Swal from "sweetalert2";

import { Helmet } from "react-helmet-async";


const PelaksanaanUjian = () => {
    const location = useLocation(); // Gunakan useLocation untuk membaca query string

    const queryParams = new URLSearchParams(location.search);

    const kode = queryParams.get('id');

    const [dataujian, setDataUjian] = useState([]); // State untuk menyimpan daftar kelas
    const [datapeserta, setDataPeserta] = useState([]);
    const [daftarpeserta, setDaraDaftarPeserta] = useState([]);
    const [interaksiAktif, setInteraksiAktif] = useState([]);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const [dataSoal, setDatasoal] = useState([]); // State untuk menyimpan daftar kelas



    useEffect(() => {
        console.log(kode)
        const docRef = doc(db, "jadwal", kode);
        const unsubscribe = onSnapshot(docRef, (docSnap) => {
            if (docSnap.exists()) {
                setDataUjian({ id: docSnap.id, ...docSnap.data() });
                setDaraDaftarPeserta(docSnap.data().daftar_peserta)
            } else {
                setDataUjian(null);
            }
        });

        return () => unsubscribe();
    }, []);

    useEffect(() => {
        if (!kode) return;
        const q = query(collection(db, "logpeserta"), where("kode_ruang", "==", kode));
        const unsubscribe = onSnapshot(q, (snapshot) => {
            setDataPeserta(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));


        });

        return () => unsubscribe();
    }, []);
    const formatTime = (timestamp) => {
        // Konversi Firebase Timestamp (seconds) ke JavaScript Date
        const date = new Date(timestamp.seconds * 1000);

        // Ambil jam, menit, dan detik
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');

        // Format menjadi "HH:MM:SS"
        return `${hours}:${minutes}:${seconds}`;
    };

    const actionprosesujian = async (id, st) => {
        try {
            const docRef = doc(db, "jadwal", id); // "jadwal" adalah nama koleksi
            await updateDoc(docRef, {
                status: st == "Aktif" ? "Selesai" : "Aktif", // Hanya update field `status`
            });
            console.log("Status berhasil diperbarui!");
        } catch (error) {
            console.error("Error updating document: ", error);
        }
    }
    const keluarhkan = async (nama, kode, idp, st) => {
        try {
            // Konfirmasi sebelum mengubah status
            const result = await Swal.fire({
                title: "Apakah kamu yakin?",
                text: `Peserta dengan Nama (${nama}) akan diubah statusnya menjadi "${st == "Mulai" ? "Keluar!" : "Beri Akses"}"`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: st == "Dikeluarkan" ? "Ya, Keluarkan!" : "Ya, Beri Akses",
                cancelButtonText: "Batal",
            });

            if (!result.isConfirmed) {
                return; // Jika user membatalkan, hentikan proses
            }

            const docRef = doc(db, "jadwal", kode);
            const docSnap = await getDoc(docRef);

            if (docSnap.exists()) {
                const currentData = docSnap.data();

                // Update hanya status peserta yang memiliki id tertentu
                const updatedPeserta = currentData.peserta.map((item) =>
                    item.id === idp.toString() ? { ...item, status: st } : item
                );

                // Update Firestore dengan peserta yang sudah diperbarui
                await updateDoc(docRef, {
                    peserta: updatedPeserta,
                });

                // Tampilkan notifikasi sukses
                Swal.fire({
                    title: "Berhasil!",
                    text: "Status peserta berhasil diperbarui.",
                    icon: "success",
                });
            } else {
                console.log("Dokumen tidak ditemukan!");
            }
        } catch (error) {
            console.error("Error updating document: ", error);

            // Tampilkan notifikasi error jika gagal
            Swal.fire({
                title: "Gagal!",
                text: "Terjadi kesalahan saat memperbarui status.",
                icon: "error",
            });
        }
    };
    const peringatan = async (nama, kode, idp, dev_id) => {
        // Menampilkan dialog SweetAlert dengan pilihan radio button
        const { value: selectedMessage } = await Swal.fire({
            title: "Beri Peringatan",
            html: `
            <div style="text-align:left">
              <label>
                <input type="radio" name="warning" value="Jangan keluar dari aplikasi"> Jangan keluar dari aplikasi
              </label><br>
              <label>
                <input type="radio" name="warning" value="Cek Terlebih Dahulu Sebelum Menyelesaikan"> Cek Terlebih Dahulu Sebelum Menyelesaikan
              </label><br>
              <label>
                <input type="radio" name="warning" value="Peringatan Terakhir"> Peringatan Terakhir
              </label><br>
              <label>
                <input type="radio" name="warning" value="custom"> Custom Pesan
              </label><br>
              <input id="customMessage" type="text" placeholder="Masukkan pesan custom" style="width:100%; margin-top:10px; padding:5px; display:none;">
            </div>
          `,
            showCancelButton: true,
            confirmButtonText: "Kirim",
            cancelButtonText: "Batal",
            preConfirm: () => {
                const selectedOption = document.querySelector('input[name="warning"]:checked');
                const customMessage = document.getElementById("customMessage").value;

                if (!selectedOption) {
                    Swal.showValidationMessage("Pilih salah satu opsi!");
                    return false;
                }

                return selectedOption.value === "custom" ? customMessage : selectedOption.value;
            },
            didOpen: () => {
                // Menampilkan input custom jika "Custom Pesan" dipilih
                document.querySelectorAll('input[name="warning"]').forEach((radio) => {
                    radio.addEventListener("change", () => {
                        document.getElementById("customMessage").style.display =
                            radio.value === "custom" ? "block" : "none";
                    });
                });
            },
        });

        if (!selectedMessage) return;

        try {
            const docRef = doc(db, "jadwal", kode);
            const docSnap = await getDoc(docRef);

            if (docSnap.exists()) {
                const currentData = docSnap.data();

                // Update status peserta berdasarkan ID
                const updatedPeserta = currentData.peserta.map((item) =>
                    item.id === idp.toString() ? { ...item, status: "Peringatan", pesan: selectedMessage } : item
                );

                await updateDoc(docRef, {
                    peserta: updatedPeserta,
                });
                const response = await fetch(`https://onesignal.com/api/v1/notifications`, {
                    method: "POST",
                    headers: {
                        'Content-Type':
                            'application/json',
                        'Authorization':
                            'Key os_v2_app_u5j6p5wghjc3nkcleebd6kobxhfv2qbncuhersvzvaeysrp5agnvqspsfecgdy6zr3zuoilieh5gal3t76cdjsbvcdwutpwt7do3pty', // Ganti dengan API Key yang benar
                    },
                    body: JSON.stringify({
                        "app_id":
                            "a753e7f6-c63a-45b6-a84b-21023f29c1b9",
                        "include_player_ids": [
                            dev_id
                        ], // Pastikan ID valid
                        "contents": {
                            "en": selectedMessage
                        },
                        "headings": {
                            "en": "Peringatan"
                        }
                    }),
                });

                if (!response.ok) {
                    throw new Error("Gagal menyimpan data");
                }


                Swal.fire("Berhasil!", "Peringatan telah dikirim.", "success");
            } else {
                Swal.fire("Error!", "Dokumen tidak ditemukan!", "error");
            }
        } catch (error) {
            console.error("Error updating document:", error);
            Swal.fire("Error!", "Terjadi kesalahan saat mengirim peringatan.", "error");
        }
    };

    const openabsensi = async () => {
        let htmlContent = '<table class="table table-hover" style="width:100%; text-align:left">';
        htmlContent += `
    <tr>
      <th>Nama</th>
      <th>Beri Akses</th>
    </tr>
  `;

        datapeserta.forEach((siswa, index) => {
            let aksen = daftarpeserta.includes(siswa.id)
            console.log(aksen)

            htmlContent += `
  <tr>
    <td>${siswa.nama}</td>
    <td>
      <input type="checkbox" name="${index}" value="${siswa.id}" ${aksen ? "checked" : ""} />
    </td>
  </tr>
`;
        });

        htmlContent += '</table>';

        Swal.fire({
            title: 'Absensi Siswa',
            html: htmlContent,
            confirmButtonText: 'Simpan',
            showCancelButton: true,
            preConfirm: () => {
                const hasil = [];

                datapeserta.forEach((siswa, index) => {
                    const radios = document.getElementsByName(`${index}`);
                    let selected = false;

                    radios.forEach(r => {
                        if (r.checked) selected = true;
                    });

                    if (selected) {
                        hasil.push(siswa.id);
                    }
                });

                return hasil;
            }
        }).then(async (result) => {
            if (result.isConfirmed) {
                // Tampilkan loading
                Swal.fire({
                    title: 'Menyimpan...',
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    }
                });

                try {
                    await prosesabsensi(result.value); // fungsi simpan data kamu
                    Swal.close(); // Tutup loading
                    Swal.fire('Berhasil!', 'Data absensi berhasil disimpan.', 'success');
                } catch (err) {
                    Swal.fire('Gagal!', 'Terjadi kesalahan saat menyimpan.', 'error');
                }
            }
        });
    };


    const prosesabsensi = async (data) => {
        try {
            const docRef = doc(db, "jadwal", kode);
            const docSnap = await getDoc(docRef);

            if (docSnap.exists()) {

                await updateDoc(docRef, {
                    daftar_peserta: data,
                });

                Swal.fire("Berhasil!", "Akses telah dikirim.", "success");
            } else {
                Swal.fire("Error!", "Dokumen tidak ditemukan!", "error");
            }
        } catch (error) {
            console.error("Error updating document:", error);
            Swal.fire("Error!", "Terjadi kesalahan saat mengirim peringatan.", "error");
        }
    }

    return (
        <>
            <Helmet>
                <title>Progres Ujian</title>
            </Helmet>
            <div>
                <div className="pc-container">
                    <div className="pc-content">
                        <div className="row">
                            <div className="col-xl-12 col-md-12">

                                <div className="card flat-card">
                                    <div className="row-table">
                                        <div className="col-sm-4 card-body w-50 br">
                                            <div className="row g-1">
                                                <div className="col-4">
                                                    <div className="b-icons bg-light-primary">
                                                        <i className="ti ti-qrcode text-secondary"></i>
                                                    </div>
                                                </div>
                                                <div className="col-8 text-md-center">

                                                    <span className="text-muted">Kode</span>
                                                    <h5>{dataujian.kode}</h5>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-4 card-body w-50 br">
                                            <div className="row g-1">
                                                <div className="col-4">
                                                    <div className="b-icons bg-light-primary">
                                                        <i className="ti ti-friends text-secondary"></i>
                                                    </div>
                                                </div>
                                                <div className="col-8 text-md-center">

                                                    <span className="text-muted">Pengawas</span>
                                                    <h5>{dataujian.nama_pengawas}</h5>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-4 card-body w-50 br ">
                                            <div className="row g-1">
                                                <div className="col-4">
                                                    <div className="b-icons bg-light-primary">
                                                        <i className="ti ti-layout-rows text-secondary"> </i>
                                                    </div>
                                                </div>
                                                <div className="col-8 text-md-center">

                                                    <span className="text-muted">Ruangan</span>
                                                    <h5>{dataujian.ruang}</h5>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-4 card-body w-50 br">
                                            <div className="row g-1">
                                                <div className="col-4">
                                                    <div className="b-icons bg-light-primary">
                                                        <i className="ti ti-calendar text-secondary"></i>
                                                    </div>
                                                </div>
                                                <div className="col-8 text-md-center">

                                                    <span className="text-muted">Pelaksanaan</span>
                                                    <h5>{dataujian.tgl}</h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row-table">
                                        <div className="col-sm-6 card-body w-50 br">
                                            <div className="row g-1">
                                                <div className="col-4">
                                                    <div className="b-icons bg-light-primary">
                                                        <i className="ti ti-layout-list text-secondary"></i>
                                                    </div>
                                                </div>
                                                <div className="col-8 text-md-center">

                                                    <span className="text-muted">Daftar Pelajaran</span>
                                                    <br />

                                                    {dataujian?.data?.map((item, index) => {

                                                        return (
                                                            <span key={item.kode + index}>{item.nama_mapel || "-"} ({item?.soal ? item?.soal?.length : 0})</span>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-3 card-body w-50">
                                            <div className="row g-1">
                                                <div className="col-4">
                                                    <div className="b-icons bg-light-primary">
                                                        <i className="ti ti-users text-secondary"></i>
                                                    </div>
                                                </div>
                                                <div className="col-6 text-md-center">
                                                    <span className="text-muted">Beri Akses Peserta</span><br />
                                                    <button onClick={() => openabsensi()} type="button" className={`btn btn-success`}><i className={`ti ti ti-user-check`}></i> Beri Akses</button>

                                                </div>

                                            </div>
                                        </div>
                                        <div className="col-sm-3 card-body w-50">
                                            <div className="row g-1">
                                                <div className="col-4">
                                                    <div className="b-icons bg-light-primary">
                                                        <i className="ti ti-git-compare text-secondary"></i>
                                                    </div>
                                                </div>
                                                <div className="col-6 text-md-center">
                                                    <span className="text-muted">Status</span><br />
                                                    <button onClick={() => actionprosesujian(dataujian.kode, dataujian?.status)} type="button" className={`btn ${dataujian?.status == "Aktif" ? 'btn-danger' : 'btn-success'} d-inline-flex`}><i className={`ti ${dataujian?.status == "Aktif" ? 'ti-player-pause' : 'ti-player-play'}`}></i> {dataujian?.status == "Aktif" ? 'SELESAI' : 'MULAI'}</button>

                                                </div>

                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>

                            <div className="col-xl-12 col-md-12">
                                <div className="card">

                                    <div className="card-body">
                                        <div className='row mb-3 align-items-center'>
                                            <div className="col"><small className="text-muted">Peserta</small><h3>Peserta Ujian</h3></div>

                                            <div className='col-auto'>
                                                {/* <button data-bs-toggle="modal" data-bs-target="#ujianModal"  type="button" className="btn btn-primary d-inline-flex"><i className="ti ti-plus me-1"></i>Download Hasil</button> */}
                                            </div>
                                        </div>
                                        <hr />

                                        <ul className='list-group list-group-flush'>
                                            {Array.isArray(daftarpeserta) && datapeserta
                                                ?.filter((item) => daftarpeserta.includes(item.id))
                                                .map((item, index) => {
                                                    const stp = dataujian?.peserta?.find((item2) => item2.id === item.id)?.status;

                                                    return (
                                                        <li key={item.id} className="list-group-item px-0">
                                                            <div className="d-flex align-items-center">
                                                                <div className="flex-shrink-0">
                                                                    <div className="dropdown">
                                                                        <a className="avtar avtar-s btn-link-secondary dropdown-toggle arrow-none" href="#" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                            <i className="ti ti-dots-vertical f-18"></i>
                                                                        </a>
                                                                        <div className="dropdown-menu">
                                                                            <a className="dropdown-item" href="#" onClick={() => keluarhkan(item.nama, dataujian.kode, item.id, stp === "Mulai" ? "Dikeluarkan" : "Mulai")}>
                                                                                {stp === "Mulai" ? "Keluarkan" : "Beri Akses"}
                                                                            </a>
                                                                            <a className="dropdown-item" href="#" onClick={() => peringatan(item.nama, dataujian.kode, item.id, item.dev_id)}>
                                                                                Beri Peringatan
                                                                            </a>
                                                                            <a className="dropdown-item" data-bs-toggle="modal" data-bs-target="#ujianModal" onClick={() => setInteraksiAktif(item.interaksi)}>
                                                                                Lihat Interaksi
                                                                            </a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="flex-grow-1 ms-3">
                                                                    <div className="row g-1">
                                                                        <div className="col-6">
                                                                            <h6 className="mb-0">{item.nama}</h6>
                                                                            <p className="text-muted mb-0"><small>{stp || "-"} | {item.progeres || "-"}</small></p>
                                                                            <p className="text-danger mb-0">
                                                                                <small>Jumlah Keluar</small> <b>{item?.interaksi ? item.interaksi.filter(i => i.status === "Keluar").length : 0}x</b>
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    );
                                                })}

                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



            <div className="modal fade" id="ujianModal" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog">
                    <div className='modal-content'>
                        <div className="modal-header">
                            <h5 className="modal-title">Interaksi</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <table className='table'>
                                <tbody>
                                    {interaksiAktif?.map((item, index) => {

                                        return (<tr key={item.dt}>

                                            <td>
                                                <i className={`ti f-24 ${item.status === "Keluar" ? "text-danger" : item.status === "Melanjutkan" ? "text-success" : "text-success"} ${item.status === "Keluar" ? "ti-arrow-narrow-left" : (item.status === "Melanjutkan" ? "ti-arrow-narrow-right" : "ti-arrow-narrow-right")}`}></i>
                                            </td>
                                            <td><h6 className={item.status === "Keluar" ? "text-danger" : item.status === "Melanjutkan" ? "text-success" : "text-success"}>{item.status}</h6></td><td><h6 className={item.status === "Keluar" ? "text-danger" : item.status === "Melanjutkan" ? "text-success" : "text-success"}>{formatTime(item.dt)}</h6></td>
                                        </tr>
                                        )
                                    })}</tbody>
                            </table></div></div>
                </div>
            </div>


        </>
    );
};

export default PelaksanaanUjian;
